<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *-->
<template>
  <s-header :name="column" :back="''"></s-header>
  <van-tabs v-model:active="active" ref="tabs">
    <van-tab v-for="(tag,index) in tags" :key="index" ref="tabs"
             :title="tag.title" class=" " :name="index.toString()"
             :to="{ path:'/infoList', query: {name:route.query.name,tag:index}}"
    >
      <div>
        <van-cell v-for="(content,index) in tag.data" :key="index" :title="content.name" is-link
                  :to="{ path:'/info', query: {id:content.id}}"/>

      </div>
    </van-tab>
  </van-tabs>
  <nav-bar/>


</template>

<script>
import sHeader from '@/components/SimpleHeader'
import {nextTick, onMounted, reactive, ref, toRefs} from "vue";
import {useRoute} from "vue-router";
import {closeToast, showLoadingToast} from "vant";
// import {setLocal} from "@/common/js/utils";
// import axios from "@/utils/axios";
// import router from "@/router";
import {infos} from '@/common/js/data'
import NavBar from "@/components/NavBar.vue";


export default {
  components: {
    NavBar,
    sHeader
  }, setup() {
    const route = useRoute()

    const state = reactive({
      active: '0',
      nickName: '',
      introduceSign: '',
      loginName: '',
      password: '',
      column: '',
      tags: [{}]
    })

    onMounted(async () => {
      await init()
    })


    const init = async () => {
      showLoadingToast({
        message: '加载中...',
        forbidClick: true
      });
      const el = ref("tabs")
      console.log(el)

      const {name, tag} = route.query
      state.tags = infos[name].tags
      state.column = infos[name].name
      // await this.$nextTick(() => {
      //   DOM 更新完毕
      // state.active = Number(tag)
      // })
      await nextTick(() => {
        state.active = tag
      })

      //
      // setTimeout(() => {
      // }, 1000)

      closeToast()
    }


    const handleLogout = async () => {
      // const {resultCode} = await logout()
      // if (resultCode === 200) {
      //   setLocal('token', '')
      //   axios.defaults.headers['token'] = localStorage.getItem('token') || ''
      //   await router.push({"path": "/home"})
      //
      //   // window.location.href = '#/home'
      // }
    }

    return {
      ...toRefs(state),
      handleLogout, route
    }
  }

}
</script>

<style lang="less" scoped>
.about {
  box-sizing: border-box;
  padding: 20px;

  .intro-img {
    width: 100%;
  }

  .about-body {
    font-size: 16px;

    a {
      color: #007fff;
    }
  }
}
</style>
